import React, { useCallback, useState, useMemo, forwardRef, useImperativeHandle, useRef, } from 'react';
import { Plate, createPlugins, getPlateActions, PlateProvider, } from '@udecode/plate';
import { Box, useBreakpointValue } from '@noom/wax-component-library';
import { isEmptyValue, calculateRowStyles } from '../utils';
import { EMPTY_VALUE } from '../constants';
import { Toolbar, BalloonToolbar } from '.';
import { defaultElementsPlugins, defaultMarksPlugins } from '../plugins';
import { MentionPopover, toMentionItem } from '../plugins/mentionPlugin';
import SocialMentionItem from '../../../../core/components/SocialMentionItem';
const renderMentionItem = (data) => {
    return (React.createElement(SocialMentionItem
    // TODO: Add rootEl with actual popover scrolling element to enable infinite scroll
    , { 
        // TODO: Add rootEl with actual popover scrolling element to enable infinite scroll
        id: data.item.key, isLastItem: data.item.data.isLastItem }));
};
const EditorClear = forwardRef(({ id }, ref) => {
    const clear = useCallback(() => {
        const plateActions = getPlateActions(id);
        plateActions.value([EMPTY_VALUE]);
        plateActions.resetEditor();
    }, [id]);
    useImperativeHandle(ref, () => ({ clear }));
    return null;
});
const plugins = createPlugins([
    ...defaultMarksPlugins,
    ...defaultElementsPlugins,
]);
const RichTextEditor = forwardRef(({ id, name, initialValue = [EMPTY_VALUE], rows, maxRows, onChange, onClear, onClick, onFocus, onBlur, onKeyPress, isDisabled, isInvalid, placeholder, prepend, append, isToolbarVisible = true, autoFocus, queryMentionees, mentionAllowed, }, ref) => {
    const clearRef = useRef(null);
    const [mentionData, setMentionData] = useState([]);
    const showBallonToolbar = useBreakpointValue({ base: false, lg: true });
    useImperativeHandle(ref, () => ({
        clear: () => {
            var _a, _b;
            (_b = (_a = clearRef.current) === null || _a === void 0 ? void 0 : _a.clear) === null || _b === void 0 ? void 0 : _b.call(_a);
        },
    }));
    const onMentionSearchChange = useCallback((search) => {
        if (search) {
            queryMentionees === null || queryMentionees === void 0 ? void 0 : queryMentionees(search, (data) => setMentionData(data.map((d) => toMentionItem(d))));
        }
    }, [setMentionData, queryMentionees]);
    function handleChange(newValue) {
        if (isEmptyValue(newValue)) {
            onClear === null || onClear === void 0 ? void 0 : onClear();
        }
        onChange({ value: newValue, lastMentionText: '', mentions: [] });
    }
    const handleFocus = React.useCallback(() => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    }, [onFocus]);
    const handleBlur = React.useCallback(() => {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    }, [onBlur]);
    const rowStyles = useMemo(() => calculateRowStyles(rows, maxRows), [rows, maxRows]);
    const editableProps = {
        name,
        onClick,
        placeholder,
        spellCheck: true,
        autoFocus,
        readOnly: isDisabled,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyDown: onKeyPress,
    };
    return (React.createElement(PlateProvider, { id: id },
        React.createElement(Toolbar, { editorId: id, isVisible: isToolbarVisible }),
        React.createElement(Box, { border: "1px solid", borderColor: isInvalid ? 'error.500' : 'gray.200', boxSizing: "border-box", borderRadius: "md", cursor: "text", paddingX: 1, paddingY: 2, sx: rowStyles },
            prepend,
            React.createElement(Plate, { id: id, plugins: plugins, onChange: handleChange, initialValue: initialValue, editableProps: editableProps },
                showBallonToolbar && React.createElement(BalloonToolbar, null),
                mentionAllowed && (React.createElement(MentionPopover, { items: mentionData, onRenderItem: renderMentionItem, onMentionSearchChange: onMentionSearchChange })),
                React.createElement(EditorClear, { id: id, ref: clearRef })),
            append)));
});
export default RichTextEditor;
//# sourceMappingURL=Editor.js.map